import _ from 'lodash';
import { getQueryParameter, setQueryParameter } from 'helpers/browser_helpers';
import { findFileInFolder, findFolderInFolder, getFirstFile } from '../helpers/folder_helpers';

import { get } from 'helpers/api';

import { setShowLogin, SET_USER_TYPE } from './ui';

export const HANDLE_NAVIGATION = 'HANDLE_NAVIGATION';
export const handleNavigation = (folder) => {
  return (dispatch, getState) => {
    const prevState = getState();
    const indexInStack = _.findIndex(prevState.navigation, { id: folder.id });
    const file = getFirstFile(folder);
    setQueryParameter('file', (file && file.id));

    if (indexInStack >= 0) {
      dispatch({ type: HANDLE_NAVIGATION, navigation: prevState.navigation.slice(0, indexInStack + 1), file });
    } else {
      dispatch({ type: HANDLE_NAVIGATION, navigation: [...prevState.navigation, folder], file });
    }
  };
};

export const PREVIEW_FILE = 'PREVIEW_FILE';
export const previewFile = (file) => {
  return (dispatch) => {
    setQueryParameter('file', file.id);

    dispatch({ type: PREVIEW_FILE, file });
    dispatch(setShowLogin(false));
  };
};

export function setUserType(userType) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_TYPE,
      payload: userType
    });
  };
}

export const DOWNLOAD_ALL_URL = 'DOWNLOAD_ALL_URL';
export function fetchNavigation(onlyGetUnlockedFile = false, updatedProfile = {}) {
  return (dispatch, getState) => {
    const { vault: { fileSharingUrl }, preview: { readonly, profile }, ui: { userType } } = getState();
    let previewProfile = { ...profile, ...updatedProfile };
    if (Object.keys(previewProfile).length === 0) previewProfile = null;

    get(fileSharingUrl, { params: { userType, readonly, previewProfile } }).then((data) => {
      const navigation = [data.rootFolder];

      const result = getValidFileAndNavigation(navigation, data, onlyGetUnlockedFile);
      dispatch({ type: DOWNLOAD_ALL_URL, downloadAllUrl: data.downloadAllUrl });
      dispatch({ type: HANDLE_NAVIGATION, navigation: result.navigation, file: result.file });
    });
  };
}

function getValidFileAndNavigation(navigation, data, onlyGetUnlockedFile) {
  let file = null;
  const gainApprovalAccess = data.rootFolder.children.find(({ accessIfApproved }) => accessIfApproved);
  if (data.profile.showFastCa && gainApprovalAccess?.id) {
    setQueryParameter('file', gainApprovalAccess.id);
    return { file: gainApprovalAccess, navigation };
  }

  const folderId = getQueryParameter('folder');
  const folderResult = findFolderInFolder(data.rootFolder, folderId);
  let folderToSearch = data.rootFolder;
  if (folderId && folderResult?.folder) {
    setQueryParameter('folder'); // removes the query param
    folderToSearch = folderResult.folder;
    navigation = folderResult.navigation;
  }

  const result = getFileFromQueryOrSearchForFirst(folderToSearch, onlyGetUnlockedFile);
  if (result?.file) {
    file = result.file;
    if (result.navigation) navigation = result.navigation;
  }

  return { file, navigation };
}

function getFileFromQueryOrSearchForFirst(folder, onlyGetUnlockedFile) {
  let file = null;
  let navigation = null;
  const fileId = getQueryParameter('file');
  const result = findFileInFolder(folder, fileId);

  if (result?.file && (!result.file.locked || !onlyGetUnlockedFile)) {
    file = result.file;
    navigation = result.navigation;
  }

  if (!file) file = getFirstFile(folder);

  if (file) setQueryParameter('file', file.id);

  return { file, navigation };
}

export const BROKER_REMINDED_AT = 'BROKER_REMINDED_AT';

export function brokerRemindedAt(timestamp) {
  return (dispatch) => {
    dispatch({ type: BROKER_REMINDED_AT, timestamp });
  };
}

export const BROKER_REMINDED_DATA = 'BROKER_REMINDED_DATA';

export function brokerRemindedData(timestamp, url) {
  return (dispatch) => {
    dispatch({ type: BROKER_REMINDED_DATA, timestamp, url });
  };
}
